import { showSuccessToast, showErrorToast } from "../components/atoms/Utlis/Toast";


export const copyDataToClipboard = (
  data: any[],
  headers: string[],
  keys: string[],
  successMsg = "Data copied to clipboard"
) => {
  try {
    const text = data
      .map((row) =>
        keys.map((key) => {
          const val = row[key];
          return val !== null && val !== undefined ? String(val) : "";
        }).join(" | ")
      )
      .join("\n");

    navigator.clipboard.writeText(text);
    showSuccessToast(successMsg);
  } catch (err) {
    showErrorToast("Failed to copy data to clipboard");
  }
};


export const exportDataToCSV = (
  data: any[],
  headers: string[],
  keys: string[],
  filename: string,
  successMsg = "CSV exported successfully"
) => {
  try {
    const headerRow = headers.map(h => `"${h}"`).join(",") + "\n";
    const bodyRows = data
      .map((row) =>
        keys
          .map((key) => {
            const val = row[key];
            const cleanVal = val !== null && val !== undefined ? String(val).replace(/"/g, '""') : "";
            return `"${cleanVal}"`;
          })
          .join(",")
      )
      .join("\n");

    const blob = new Blob([headerRow + bodyRows], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    showSuccessToast(successMsg);
  } catch (err) {
    showErrorToast("Failed to export CSV");
  }
};


export const exportDataToExcel = (
  data: any[],
  headers: string[],
  keys: string[],
  filename: string,
  successMsg = "Excel exported successfully"
) => {
  try {
    const headerRow = headers.join("\t") + "\n";
    const bodyRows = data
      .map((row) =>
        keys
          .map((key) => {
            const val = row[key];
            return val !== null && val !== undefined ? String(val).replace(/\t/g, " ") : "";
          })
          .join("\t")
      )
      .join("\n");

    const blob = new Blob([headerRow + bodyRows], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    showSuccessToast(successMsg);
  } catch (err) {
    showErrorToast("Failed to export Excel");
  }
};
